import { render, staticRenderFns } from "./DetailStoreShippingComponent.vue?vue&type=template&id=4f49b19a&scoped=true"
import script from "./DetailStoreShippingComponent.vue?vue&type=script&lang=js"
export * from "./DetailStoreShippingComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailStoreShippingComponent.vue?vue&type=style&index=0&id=4f49b19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f49b19a",
  null
  
)

export default component.exports